import React, { FunctionComponent } from 'react';
import styles from './sticky-section.module.scss';
import classNames from 'classnames/bind';
import Section from '../../section/section';

export interface IStickySectionProps {
  content: IKontentItem[];
  backgroundColor: string;
  sectionId: string;
}

const cx = classNames.bind(styles);

export const StickySection: FunctionComponent<IStickySectionProps> = ({
  content,
  backgroundColor,
  sectionId
}) => {
  const sectionClass = cx({
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent'
  });

  return (
    <div className={`${styles.container} ${sectionClass}`} id={sectionId}>
      <div className={styles.itemsWrapper}>
        {content &&
          content.map((item: IKontentItem, i) => (
            <Section linkedItem={item} key={i} />
          ))}
      </div>
    </div>
  );
};
